import { ExactPartial }	from "ts-base/type";
import { Equal }		from "ts-base/equal";
import { Comparator }	from "ts-base/comparator";

export type DateOffset	= Readonly<{
	years:		number,
	months:		number,
	days:		number,
	hours:		number,
	minutes:	number,
	seconds:	number,
	millis:		number,
}>;

export namespace DateOffset {
	export type Partial = ExactPartial<DateOffset>;

	export const fromPartial	= (offset:Partial):DateOffset	=> ({
		years:		offset.years	?? 0,
		months:		offset.months	?? 0,
		days:		offset.days		?? 0,
		minutes:	offset.minutes	?? 0,
		hours:		offset.hours	?? 0,
		seconds:	offset.seconds	?? 0,
		millis:		offset.millis	?? 0,
	});

	export const negate	= (offset:DateOffset):DateOffset	=> ({
		years:		-offset.years,
		months:		-offset.months,
		days:		-offset.days,
		hours:		-offset.hours,
		minutes:	-offset.minutes,
		seconds:	-offset.seconds,
		millis:		-offset.millis,
	});

	export const zero:DateOffset	= {
		years:		0,
		months:		0,
		days:		0,
		hours:		0,
		minutes:	0,
		seconds:	0,
		millis:		0,
	};

	//-----------------------------------------------------------------------------
	//## typeclasses

	export const equal:Equal<DateOffset>	= (a:DateOffset, b:DateOffset):boolean	=>
		a.years		=== b.years		&&
		a.months	=== b.months	&&
		a.days		=== b.days		&&
		a.hours		=== b.hours		&&
		a.minutes	=== b.minutes	&&
		a.seconds	=== b.seconds	&&
		a.millis	=== b.millis;

	export const compare:Comparator<DateOffset> = (a:DateOffset, b:DateOffset) =>
		a.years		< b.years	? -1 : a.years		> b.years	? +1 :
		a.months	< b.months	? -1 : a.months		> b.months	? +1 :
		a.days		< b.days	? -1 : a.days		> b.days	? +1 :
		a.hours		< b.hours	? -1 : a.hours		> b.hours	? +1 :
		a.minutes	< b.minutes	? -1 : a.minutes	> b.minutes	? +1 :
		a.seconds	< b.seconds	? -1 : a.seconds	> b.seconds	? +1 :
		a.millis	< b.millis	? -1 : a.millis		> b.millis	? +1 :
		0;
}
